import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';

type GetHeaderCellsCreateType = {
    style: Record<string, string>;
    translate: ITranslateMethod;
    translationKey?: string;
    titleClassName?: string;
    amountClassName?: string;
}

export const getHeaderCellsCreator = ({
    style, translate, translationKey }: GetHeaderCellsCreateType) => (item: IBonusToDisplay) => {
    const { amount } = item;
    const bonusName = item.marketingName || item.templateName;

    return [
        {
            id: 0,
            content: bonusName,
            className: `${style.title} accordionHeaderSmallDetails`
        },
        {
            id: 1,
            content: translationKey ? `${amount} ${translate(translationKey)}` : amount,
            className: `${style.amount} accordionHeaderSmallDetails`
        }
    ];
};
